export const SYNC_ROOMS_SCENES = '@@roomsScenes/syncRoomsScenes'

export const RESET_ROOMS_SCENES = '@@roomsScenes/reset'

export const UPDATE_ROOMS_SCENES = '@@roomsScenes/updateRoomsScenes'
